import { Grid } from '@mui/material';
import logo from '../SaveTheDate.jpg';

export function HomePage() {
    return (
        <Grid container alignItems="center" justifyContent="center">
            <Grid size={{ xs: 12, sm: 8 }}>
                <img style={{ maxWidth: '100%' }} src={logo} alt="Save the Date" />
            </Grid>
        </Grid>
    );
}
